import React, {
  createContext, useContext,
  useState, useEffect
} from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem(
      'ironwall_user'
    );
    const token = localStorage.getItem(
      'ironwall_token'
    );
    if (savedUser && token) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    localStorage.setItem('ironwall_token', token);
    localStorage.setItem(
      'ironwall_user',
      JSON.stringify(userData)
    );
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('ironwall_token');
    localStorage.removeItem('ironwall_user');
    setUser(null);
    window.location.href = '/login';
  };

  const isPlatformAdmin =
    user?.userType === 'platform_admin';
  const isVendorUser =
    user?.userType === 'vendor_user';
  const isVendorAdmin =
    user?.role === 'vendor_admin';
  const isCustomer =
    user?.userType === 'customer';

  return (
    <AuthContext.Provider value={{
      user, login, logout, loading,
      isPlatformAdmin, isVendorUser,
      isVendorAdmin, isCustomer,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error(
      'useAuth must be used within AuthProvider'
    );
  }
  return context;
};